import React from "react";
import PropTypes from "prop-types";

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';

import {cartItemInterface} from "../../../shoppingCart/cartItemInterface";
import LookListMainFeatureActionsPopperButtons from "./lookListMainFeatureActionsPopperButtons";

const LookListMainFeatureActionsPopper = (props) => {

  const {anchorEl, moreOpened, setMoreOpened, cartItem} = props;

  const closePopper = () => {
    setMoreOpened(false)
  }

  return (
    <Popper open={moreOpened}
            className="ll-feature__actions-popper"
            id={cartItem.id + "-modal"}
            anchorEl={anchorEl.current}
            placement={"left-start"}
            transition
            disablePortal={true}>
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: "right top" }}
        >
          <Paper>
            <ClickAwayListener onClickAway={closePopper}>
              <div>
                <LookListMainFeatureActionsPopperButtons cartItem={cartItem} closePopper={closePopper}/>
              </div>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
};

LookListMainFeatureActionsPopper.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface).isRequired,
  anchorEl: PropTypes.any.isRequired,
  moreOpened: PropTypes.bool.isRequired,
  setMoreOpened: PropTypes.func.isRequired,
}

export default LookListMainFeatureActionsPopper
